import {
  postAjax, postAjaxFile,
  postAjaxFormData
} from '../helpers/ajax'

export default class AjaxFormSubmission {
  constructor(formSelector, msg, {
                hideOnSuccess = null,
                redirectAfterSuccess = null,
              },fromCareer = null
  ) {
    this.formSelector = formSelector
    this.msg = this.formSelector + ' ' + msg;
    this.redirectAfterSuccess = redirectAfterSuccess
    this.hideOnSuccess = hideOnSuccess;
    this.userLang = document.documentElement.lang;
    this.fromCareer = fromCareer;
  }

  init() {
    $(this.formSelector).submit((event) => {
      if($(this.formSelector).find("input[name='g-recaptcha-response']").length >0 ){
        let that = this;
        grecaptcha.ready(function() {
          grecaptcha.execute('6Le1XMEZAAAAAH4ScUO9vwt5Vmeyg6p3hM1qYQUt', {action: 'submit'}).then(function(token) {
            $(that.formSelector).find("input[name='g-recaptcha-response']").val(token);
            event.preventDefault();
            //let data = new FormData(this);
            let data = $(that.formSelector).serialize();
            let action = $(that.formSelector).attr('action');
            if (that.hideOnSuccess) {
              that.postFormWiringAjax(data, action);
            } else {
              that.postFormAjax(data, action);
            }
          });
        });
      }else{
        event.preventDefault();
        //let data = new FormData(this);
        let data = $(this.formSelector).serialize();
        let action = $(this.formSelector).attr('action');
        if (this.hideOnSuccess) {
          this.postFormWiringAjax(data, action);
        } else {
          this.postFormAjax(data, action);
        }
      }

      return false;
    })
  }

  sendFormApplication() {
    $().ready(() => {
      let self = this;
      $("#submitForm").click(function (event) {
        event.preventDefault();
        var form = $(self.formSelector);
        var formdata = false;
        if (window.FormData) {
          formdata = new FormData(form[0]);
          formdata.append('userLang', self.userLang)
        }
        $.ajax({
          url: '/ajax/application.php',
          enctype: 'multipart/form-data',
          data: formdata ? formdata : form.serialize() + '&userLang=' + self.userLang,
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          success: function (response, textStatus, jqXHR) {
            if (response.success) {
              if (self.redirectAfterSuccess) {
                window.location = self.redirectAfterSuccess;
              } else {
                $(self.msg).removeClass('alert-danger');
                $(self.msg).addClass('d-block alert-success').html(response.success);
              }
            } else {
              $(self.msg).removeClass('alert-success');
              $(self.msg).empty();
              $('.txt-msg').remove();
              if (response.error) {
                if (response.error.constructor === String) {
                  $(self.msg).addClass('d-block alert-danger').html(response.error);
                } else {
                  for (let item in response.error) {
                    $('#' + item).after('<p class="text-left text-primary txt-msg font-weight-bold">' + response.error[item] + '</p>')
                  }
                  $('html, body').animate({
                    scrollTop: $('.txt-msg:visible:first').prev().offset().top
                  }, 1000);
                }
                if (document.querySelector('.recaptcha')) {
                  grecaptcha.reset();
                }
              }
            }
          },
          catch: function(response){
          }
        });
        return false
      });
    })
  }

  postFormWiringAjax(data, action) {
    postAjax(action, data, (response) => {
      response = Object.setPrototypeOf(response, Object.prototype);
      if (response.success) {
        let elKey = document.querySelector('.key-element')
        if (elKey) {
          elKey.classList.remove('d-none');
          elKey.classList.add('d-flex');
        }

        let elLogin = document.querySelector('.login-element')
        if (elLogin) {
          elLogin.classList.remove('d-block');
          elLogin.classList.add('d-none');
        }
      } else {
        $(this.msg).removeClass('alert-success');
        $(this.msg).addClass('d-block alert-danger').html(response.error);
      }
    });
  }

  postFormAjax(data, action) {
    postAjaxFile(action, data, (response) => {
      response = Object.setPrototypeOf(response, Object.prototype);
      if (response.success) {
        if (this.redirectAfterSuccess) {
          window.location = this.redirectAfterSuccess
        } else {
          $(this.msg).removeClass('alert-danger')
          $(this.msg).addClass('d-block alert-success').html(response.success)
          $(this.formSelector).trigger("reset")
          this.resetAlertMsgOnSidepartNavigation()
        }
      } else {
        $(this.msg).removeClass('alert-success');
        $(this.msg).empty();
        $('.txt-msg').remove();
        if (response.error) {

          if (typeof response.error === 'string') {
            try {
              response.error = JSON.parse(response.error);
            } catch {
              /* Not a Json, we leave it */
            }
          }

          let globalMsg = null;
          if (response.error?.errors && (response.error.errors.fr || response.error.errors.en)) {
            const {fr, en} = response.error.errors;
            globalMsg = response.error.errors[this.userLang] || en || fr;

            delete response.error.errors;
            if (!Object.keys(response.error).length) {
              response.error = {};
            }
          }

          if (globalMsg) {
            $(this.msg)
              .addClass('d-block invalid-feedback')
              .removeClass('d-none')
              .html(globalMsg);
          }

          if (typeof response.error === 'string') {
            $(this.msg)
              .addClass('d-block invalid-feedback')
              .removeClass('d-none')
              .html(response.error);
          } else {
            for (const [field, message] of Object.entries(response.error)) {
              const $field = $(`#${field}`);

              if ($field.next('.invalid-feedback').length) {
                $field.removeClass('is-invalid');
                $field.siblings('.invalid-feedback').remove();
              }

              $field
                .addClass('is-invalid')
                .after(`<div class="invalid-feedback">${message}</div>`);
            }

            const $scrollToEl = $(
              `${this.formSelector} .invalid-feedback:visible:first`
            ).parent('.form-group');

            const headerHeight = $('.fortin-header').height() || 0;

            if ($scrollToEl.length) {
              $('html, body').animate(
                {scrollTop: $scrollToEl.offset().top - headerHeight},
                1000
              );
            }
          }
          if (document.querySelector('.recaptcha')) {
            grecaptcha.reset();
          }
        }
      }
    });
  }

  //reset confirmation msg or error msg on click on nav link in sidepart
  resetAlertMsgOnSidepartNavigation() {
    let navLink = document.querySelectorAll('.sidepart .nav-link')
    if (navLink.length > 0) {
      navLink.forEach(element => {
        element.addEventListener('click', () => {
          let msgArray = document.querySelectorAll('.form-msg.d-block')
          if (msgArray.length > 0) {
            msgArray.forEach(msg => {
              msg.classList.remove('d-block')
            });
          }
        })
      });
    }
  }
}
